export const toggleLang = {
  props: ["lang"],
  data() {
    return {
      app: {},
    };
  },
  methods: {
    toggle(zh, en) {
      switch (this.lang) {
        case "zh":
          this.app = zh;
          break;
        case "en":
          this.app = en;
          break;
        default:
          this.app = en;
      }
    },
  },
};
